import { render, staticRenderFns } from "./getonthesea.vue?vue&type=template&id=cb9a5594&scoped=true&"
import script from "./getonthesea.vue?vue&type=script&lang=js&"
export * from "./getonthesea.vue?vue&type=script&lang=js&"
import style0 from "./getonthesea.vue?vue&type=style&index=0&id=cb9a5594&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9a5594",
  null
  
)

export default component.exports